$(function () {
	const $idLikeTo = $('#idLikeTo'),
		$idLikeToBtn = $idLikeTo.find('#idLikeToBtn'),
		$idLikeToCloseBtn = $idLikeTo.find('.idLikeToDropdown-header button');

	$idLikeToBtn.on('click', function () {
		modalControl();
	});

	$idLikeToCloseBtn.on('click', function () {
		modalControl();
	});

	$(document).keyup(function (e) {
		if (e.key === "Escape") {
			modalControl('esc');
		}
	});

	$('.idLikeTo-backdrop').on('click', function () {
		modalControl('esc');
	})

	function modalControl(eventType = '') {
		let isExpanded = $idLikeToBtn.attr('aria-expanded') === 'true' ? true : false;

		$idLikeToBtn.attr('aria-expanded', isExpanded ? 'false' : 'true');
		$idLikeToCloseBtn.attr('aria-expanded', isExpanded ? 'false' : 'true');

		if (eventType === 'esc') {
			if (isExpanded) {
				remove_trap_focus($idLikeTo, 'idLikeToTrap');
				$('#idLikeToDropdown').fadeOut(300);
				$('.idLikeTo-backdrop').fadeOut(300);
			}
		} else {
			if (isExpanded) {
				remove_trap_focus($idLikeTo, 'idLikeToTrap');
				$('#idLikeToDropdown').fadeOut(300);
				$('.idLikeTo-backdrop').fadeOut(300);
			} else {
				trap_focus($idLikeTo, 'idLikeToTrap');
				$('#idLikeToDropdown').fadeIn(300);
				$('.idLikeTo-backdrop').fadeIn(300);
			}
		}
	}
});